import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/common.scss'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import { formatNumber } from "@/utils/common";
Vue.prototype.$FormatNumber = formatNumber;

Vue.config.productionTip = false
import { GetUserInfo } from "@/api/Perfil";

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    if (location.search) this.$store.commit('SETSEARCHPARAMS', location.search);
    this.setFontSize();
    setInterval(() => {
      if (this.$store.state.userInfo.token && this.$route.path !== '/Scratch' && this.$route.path !== '/withdraw/normal' && this.$route.path !== '/iof' && this.$route.path !== '/TAXAIOF' && this.$route.path !== '/qrcode') {
        GetUserInfo().then(res => {
          this.$store.commit('SETCASH', res);
          this.$store.commit('SETPAYINCASHLIST', res.payInCashList);
        });
      }
    }, 2000);
  },
  mounted() {
    window.addEventListener('resize', this.setFontSize);
  },
  methods: {
    // 计算根元素 FontSize，设置 rem
    setFontSize () {
      document.documentElement.style.fontSize = `${document.documentElement.clientWidth / 24}px`;
    }
  },
}).$mount('#app')
